module.exports = __webpack_public_path__ + "assets/img/why-us.43cd5e9c.webp";